import React, { useState, useEffect } from 'react'
import { View, Button, Text, StyleSheet, TouchableOpacity, Image } from 'react-native'
import { CameraView, CameraType, useCameraPermissions } from 'expo-camera'
import { Ionicons, Feather } from '@expo/vector-icons'
import { Loader } from './Components/Loader'
import * as ImageManipulator from 'expo-image-manipulator'

export const CameraComponent = ({ closeCamera, handleImagePickerResult }) => {
    const [permission, requestPermission] = useCameraPermissions()
    const [cameraRef, setCameraRef] = useState<CameraView | null>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [cameraSet, changeCamera] = useState(false)
    let cameraType: CameraType = cameraSet ? 'front' : 'back'
    
    useEffect(() => {
        if (!permission) {
            requestPermission()
        }
    }, [])

    const takePicture = async () => {
        setIsLoading(true)
        if (cameraRef) {
            const photo = await cameraRef.takePictureAsync({ imageType: 'jpg', quality: 0.3 })
            console.log('FOTO', photo)
            if (photo && photo.uri) {
                const resizedPhoto = await resizeIfNecessary(photo.uri, photo.width, photo.height)
                console.log('FOTO RESIZE', resizedPhoto)
                await handleImagePickerResult(resizedPhoto.uri)
            }

            closeCamera()
        }

        setIsLoading(false)
    }

    if (!permission) {
        return <Loader />
    }
    if (!permission.granted) {
        return <Text>No access to camera</Text>
    }

    return (
        <View style={styles.container}>
            <CameraView style={styles.camera} facing={cameraType} ref={(ref) => setCameraRef(ref)}>
                <View style={styles.buttonContainer}>
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <View
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingHorizontal: 20,
                                alignContent: 'center',
                                alignItems: 'flex-end',
                                marginBottom: 20,
                            }}
                        >
                            <View
                                style={{
                                    flex: 1,
                                    alignItems: 'center',
                                    height: 80,
                                    justifyContent: 'center',
                                }}
                            >
                                <TouchableOpacity
                                    style={{ alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}
                                    onPress={() => closeCamera()}
                                >
                                    <View
                                        style={{
                                            backgroundColor: 'black',
                                            height: 48,
                                            width: 48,
                                            position: 'absolute',
                                            opacity: 0.4,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            borderRadius: 25,
                                        }}
                                    />
                                    <Feather name='chevron-left' size={32} color='white' style={{ position: 'absolute' }} />
                                </TouchableOpacity>
                            </View>
                            <TouchableOpacity style={{ flex: 1, alignItems: 'center' }} onPress={() => takePicture()}>
                                <Image style={{ width: 80, height: 80 }} source={require('../../../assets/camera_button.png')} />
                            </TouchableOpacity>
                            <View
                                style={{
                                    flex: 1,
                                    alignItems: 'center',
                                    height: 80,
                                    justifyContent: 'center',
                                }}
                            >
                                <TouchableOpacity
                                    style={{ alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}
                                    onPress={() => changeCamera(!cameraSet)}
                                >
                                    <View
                                        style={{
                                            backgroundColor: 'black',
                                            height: 48,
                                            width: 48,
                                            position: 'absolute',
                                            opacity: 0.4,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            borderRadius: 25,
                                        }}
                                    />
                                    <Feather name='refresh-ccw' size={24} color='white' style={{ position: 'absolute' }} />
                                </TouchableOpacity>
                            </View>
                        </View>
                    )}
                </View>
            </CameraView>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    camera: {
        flex: 1,
        width: '100%',
    },
    buttonContainer: {
        flex: 1,
        backgroundColor: 'transparent',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-end',
    },
})

export const resizeIfNecessary = async (uri, width, height) => {
    // Verificar si alguna dimensión excede el límite
    if (width > 1080 || height > 1080) {
        // Calcular las nuevas dimensiones manteniendo la proporción
        const aspectRatio = width / height
        let newWidth = width
        let newHeight = height
        if (width > height) {
            newWidth = 1080
            newHeight = Math.round(1080 / aspectRatio)
        } else {
            newHeight = 1080
            newWidth = Math.round(1080 * aspectRatio)
        }

        // Redimensionar la imagen
        return await ImageManipulator.manipulateAsync(uri, [{ resize: { width: newWidth, height: newHeight } }], {
            compress: 1,
            format: ImageManipulator.SaveFormat.JPEG,
        })
    }
    // Devolver la imagen original si no necesita redimensionarse
    return { uri }
}
